import HtzImage from './HtzImage';

export * from './HtzImage';

export default HtzImage;
